<template>
    <div id="content" v-if="!loading">
      <popup v-show="hasPopup"
             :popup-type="getPopupType"
             :popup-action="getPopupAction"
             @popup-action="executePopupAction" />
      <form action="#">
        <div class="inner">
          <p class="paging">
            <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
          </p>

          <p class="buttons">
            <a v-if="$_deleteActionAllowed" class="btn btn_action btn_delete" :title="'Smazat' | translate"
               @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
          </p>

          <h1>{{ entity.name }}</h1>
        </div>

        <div id="responsiveTabs" class="responsiveTabs r-tabs">
            <ul class="tabs r-tabs-nav">
                <li :class="{'r-tabs-state-active' : this.$route.name === 'advertisingProviderSettings'}"><a
                    @click.stop="openRoute('advertisingProviderSettings')" v-translate>Vlastnosti</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'advertisingProviderChannelGroups'}"><a
                    @click.stop="openRoute('advertisingProviderChannelGroups')" v-translate>Skupiny kanálů</a></li>
            </ul>

            <keep-alive>
                <router-view
                    :entity="entity"
                    :isEditable="$_updateActionAllowed"
                    @saveEntity="submitForm"
                    @deleteProvider="deleteProvider"
                />
            </keep-alive>

        </div>
      </form>
    </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"

export default {
    name: 'AdvertisingProviderDetail',
    mixins: [
        detailActions,
    ],
    data() {
        return {
            entityName: 'advertisingProvider',
            moduleName: 'advertisingProviders',
            loading: true,
            updateFields: [
                'name',
                'code',
                'module_type',
                'authentication_data',
            ],
        }
    },
    created(AdvertisingProviderService) {
        this.entityService = AdvertisingProviderService
        this.createdInit()
    },
    beforeDestroy() {
        this.activateTab('settings')
    },
    methods: {
      deleteProvider() {
        this.deleteEntity(false)
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/advertisingProviders/AdvertisingProviderDetail.vue